import {Flow, FlowFile} from "../../../../lib/src/api/repositories/flows-repository";
import {FC} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPauseCircle, faPlayCircle} from "@fortawesome/free-solid-svg-icons";
import {useNavigate} from "react-router-dom";
import DataTable from "../../../../lib/src/components/data-table/DataTable";

export const FlowIndexTable: FC<{isLoading: boolean, flows: Flow[]}> = props => {
  const navigate = useNavigate()

  const sortedFlows = props.flows.sort((a,b) => a.name.localeCompare(b.name))

  return <DataTable<Flow> keyProperty={'id'} loading={props.isLoading} data={sortedFlows} columns={[
    {property: 'name', header: 'Naam'},
    {property: 'enabled', header: 'Actief', transform: (enabled) => <span className={`font-medium ${enabled ? 'text-green-700' : 'text-slate-600'}`}><FontAwesomeIcon icon={enabled ? faPlayCircle : faPauseCircle} className={'mr-1'} />{enabled ? 'Actief' : 'Gepauzeerd'}</span>},
  ]} onClickRow={(row) => {navigate(`/flows/${row.id}`)}} placeholder={'Nog geen flows'}/>
}